<template>
  <div class="card">
    <div class="my-2 px-2">
      <DateQuerySetter
        btnTitle="Go"
        @onClickGo="onClickGo"
      >
        <div class="col-12 col-sm-6 col-md-3 col-lg-2">
          <label class="col-form-label">Staff Serial No</label>
          <input
            v-model="staffSerialNo"
            type="text"
            class="form-control"
            placeholder="Staff Serial No"
          >
        </div>
        <div class="col-12 col-sm-6 col-md-3 col-lg-2">
          <label class="col-form-label">Ref Serial No</label>
          <input
            v-model="refSerialNo"
            type="text"
            class="form-control"
            placeholder="Ref Serial No"
          >
        </div>
      </DateQuerySetter>
    </div>
    <div class="col-12 px-2 mt-2">
      <ListTable
          :purchase="purchaseList"
          :userInfo="userInfo"
          @onEdit="onEdit"
      />
    </div>
    <div class="px-2"><Pagination :offset="offset" @onPageChange="onPageChange" ref="pagination"/></div>
  </div>
</template>

<script setup>
import DateQuerySetter from '@/components/atom/DateQuerySetter'
import { ref, inject, onMounted, computed  } from 'vue'
import { useStore } from 'vuex'
import { useRouter, useRoute } from 'vue-router'
import handlePurchase from '@/services/modules/purchase'
import Pagination from '@/components/atom/Pagination'
import handleContact from "@/services/modules/contact";
import ListTable from "@/components/molecule/company/sdm/pos-invoice/ListTable.vue";
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";
import { resetPaginationPage } from '@/services/utils/global';

const emit = defineEmits(['onEdit'])

const router = useRouter()
const store = useStore()
let offset = ref(20)
let purchaseList = ref([])
let contactProfileId = ref(null)
let staffSerialNo = ref(null)
let refSerialNo = ref(null)
const route = useRoute()
const userInfo = ref({})

const {fetchSalesList} = handlePurchase()
const {fetchContactProfiles} = handleContact();
const {formatPatientLabel} = useAsyncDropdownHelper()

const companyId = computed(() => {
  return route.params.companyId
})
const startDate = computed(() => {
  return route.query.start
})
const endDate = computed(() => {
  return route.query.end
})
const page = computed(() => {
  return route.query.page
})

function getQuery () {
  let query = '?company_id=' + companyId.value
  if(!!contactProfileId.value) query += '&contact_profile_id='+contactProfileId.value
  if(!!staffSerialNo.value) query += '&staff_serial_no='+staffSerialNo.value
  if(!!refSerialNo.value) query += '&ref_serial_no='+refSerialNo.value
  if(!startDate.value && !endDate.value) return query
  if(startDate.value) query += '&start_date='+startDate.value
  if(endDate.value) query += '&end_date='+endDate.value
  if(page.value) query += '&page='+page.value
  query += '&sale_type=pos_invoice'
  query += '&offset='+offset.value
  return query
}

async function onClickGo() {
  fetchSalesList(getQuery())
    .then(async res => {
      if (! res.status) {
        purchaseList.value = []
        userInfo.value = {}
        resetPaginationPage(store, route, router)
        return
      }
      purchaseList.value = res.date.data
      userInfo.value = res.user
      await setPagination(res.date)
    })
}

const setPagination = async (data) => {
  if(!data.data.length) return
  store.commit('setPaginationData', {
    records: data.total,
    perPage: data.per_page,
    currentPage: data.current_page,
  })
}

function onEdit(id) {
  emit('onEdit', id)
}

const onPageChange = async (page) => {
  let routeQuery = Object.assign({}, route.query)
  routeQuery.page = page
  await router.push({path: route.path, query: routeQuery})

  await onClickGo();
}

onMounted(() => {
  onClickGo()
})

defineExpose({ onClickGo })

</script>
